import {Injectable, InjectionToken} from "@angular/core";
import {DxEncryptionStrategyType} from "./dx-encryptions-type";


/**
 *  Инжектируемый класс настроек ядра.
 *  @publicApi
 */
@Injectable()
export class DxCoreConfig {
  /**
   *  Ссылка на объект `environment`, харнящий данные о среде на которую приложение было собрано.
   *  @name env
   *  @type {any}
   */
  public env: any;

  /**
   *  Тип стратегии шифрования данных в приложении.
   *  @name encryptionStrategyType
   *  @type {DxEncryptionStrategyType}
   */
  public encryptionStrategyType: DxEncryptionStrategyType;

  /**
   *  Имя роута для возврата в систему после перехода на аварийную страницу.
   *  Опциональный параметр.
   *  @name goBackRoute
   *  @type {string}
   */
  public goBackRoute?: string;

  /**
   *  Имя роута для перехода на аварийную страницу.
   *  @name errorRoute
   *  @type {string}
   */
  public errorRoute: string;


  /**
   *  Создает инстанс конфигурации ядра.
   *  @constructor
   *  @param {Partial<DxCoreConfig>} config - объект с настроками ядра.
   */
  constructor(config: Partial<DxCoreConfig>) {
    this.env = config.env;
    this.encryptionStrategyType = config.encryptionStrategyType;
    this.goBackRoute = config.goBackRoute;
    this.errorRoute = config.errorRoute;
  }
}


/**
 *    Эти константы объявлены здесь потому что объявление их в dx-core.module
 *    c последующим использованием в сервисах ядра-же приводит к возникновению
 *    циклических зависимостей типа: module -> service -> module.
 */

/**
 * Токен для регистрации провайдера конфигурации ядра и распространения конфигурации через механизм DI.
 * @publicApi
 */
export const DX_CORE_CONFIG = new InjectionToken<DxCoreConfig>('DX_CORE_CONFIG');
